import React from 'react';

export type VersionSelectContextMenuContextType = {
  openEdit: () => void;
  openNew: () => void;
  handleDelete: (version: string) => void;
  selectedVersion: string;
};

export const VersionSelectContextMenuContext =
  React.createContext<VersionSelectContextMenuContextType | null>(null);

export const useVersionSelectContextMenu =
  (): VersionSelectContextMenuContextType => {
    const context = React.useContext(VersionSelectContextMenuContext);
    if (!context) {
      throw new Error(
        'useVersionSelectContextMenu must be used within VersionSelectContextMenu'
      );
    }
    return context;
  };
